/** Sentinel UEN meaning “no Singapore entity / not applicable”. */
export const UEN_NA = 'NA';

const NA_ALIASES = new Set(['NA', 'N/A', 'N.A.', 'N.A', 'NONE', 'NIL']);

export function isUenMarkedNa(uen: string | null | undefined): boolean {
  return NA_ALIASES.has((uen ?? '').trim().toUpperCase());
}

/** Normalize stored/draft UEN — collapse NA aliases to `NA`. */
export function normalizeClientUen(uen: string | null | undefined): string {
  const trimmed = (uen ?? '').trim().toUpperCase();
  if (!trimmed) return '';
  if (isUenMarkedNa(trimmed)) return UEN_NA;
  return trimmed;
}

/** True when the account no longer needs a UEN assignment (real UEN or NA). */
export function clientHasUenValue(uen: string | null | undefined): boolean {
  return Boolean((uen ?? '').trim());
}
